__turbopack_context__.v({
  "icon": "styles-module-scss-module__-cxZzq__icon",
  "wrapper": "styles-module-scss-module__-cxZzq__wrapper",
});
